import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CoverShowComponentProps as Props } from '../../../types/recruitments';
import { useSwapCoverThumbsSlider } from '../../../hooks/useSwapCoverThumbsSlider';

export const Component: FunctionComponent<Props> = (props) => {
  const {
    displayImages,
    currentIndex,
    handleSubImageClick
  } = useSwapCoverThumbsSlider(props.images, props.noimage);

  return (
    <Presentation
      {...props}
      displayImages={displayImages}
      currentIndex={currentIndex}
      handleSubImageClick={handleSubImageClick}
    />
  );
};
